import { alpha } from '@mui/material/styles';

export function observationScaleTone(value) {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === 'gelistirilmeli') return 'warning';
  if (normalized === 'orta') return 'info';
  if (normalized === 'iyi') return 'success';
  return 'default';
}

export function observationScaleToggleButtonSx(value) {
  return (theme) => {
    const tone = observationScaleTone(value);
    if (tone === 'default') {
      return {
        textTransform: 'none',
        fontWeight: 700,
      };
    }

    const main = theme.palette[tone]?.main || theme.palette.primary.main;
    const dark = theme.palette[tone]?.dark || theme.palette.text.primary;

    return {
      textTransform: 'none',
      fontWeight: 700,
      borderColor: theme.palette.divider,
      color: theme.palette.text.secondary,
      '&:hover': {
        borderColor: alpha(main, 0.35),
        bgcolor: alpha(main, 0.06),
      },
      '&.Mui-selected': {
        borderColor: alpha(main, 0.55),
        bgcolor: alpha(main, 0.14),
        color: dark,
      },
      '&.Mui-selected:hover': {
        borderColor: alpha(main, 0.65),
        bgcolor: alpha(main, 0.18),
      },
    };
  };
}

export function observationScaleChipSx(value) {
  return (theme) => {
    const tone = observationScaleTone(value);
    if (tone === 'default') {
      return {
        minWidth: 104,
        justifyContent: 'center',
      };
    }

    const main = theme.palette[tone]?.main || theme.palette.primary.main;
    const dark = theme.palette[tone]?.dark || theme.palette.text.primary;
    return {
      minWidth: 104,
      justifyContent: 'center',
      bgcolor: alpha(main, 0.14),
      color: dark,
      borderColor: alpha(main, 0.4),
      '& .MuiChip-label': {
        fontWeight: 700,
      },
    };
  };
}